import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { buildPostAuthPath } from "@/lib/authRedirect";

const KEY = "siis_claim_token";

/** Secure athlete claim: token moved out of the URL immediately, redeemed server-side after sign-in. */
const ClaimProfile = () => {
  const { user, loading } = useAuth();
  const [token, setToken] = useState<string | null>(null);
  const [state, setState] = useState<"idle" | "working" | "error">("idle");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const url = new URL(window.location.href);
    const t = url.searchParams.get("t");
    if (t && /^[a-f0-9]{64}$/.test(t)) sessionStorage.setItem(KEY, t);
    if (t) window.history.replaceState(null, "", "/claim");
    setToken(sessionStorage.getItem(KEY));
  }, []);

  const redeem = async () => {
    if (!token) return;
    setState("working");
    const { error } = await supabase.rpc("redeem_athlete_claim_link", { _token: token });
    if (error) { setState("error"); setMsg(error.message); return; }
    sessionStorage.removeItem(KEY);
    window.location.assign("/dashboard/quick-start");
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md w-full rounded-2xl bg-card p-8 shadow-card text-center">
          <h1 className="font-display text-3xl">Claim your SIIS profile</h1>
          {!token ? (
            <p className="mt-3 text-muted-foreground">This claim link is invalid or has expired. Ask SIIS for a new one.</p>
          ) : loading ? (
            <p className="mt-3 text-muted-foreground">Loading…</p>
          ) : !user ? (
            <>
              <p className="mt-3 text-muted-foreground">Sign in or create your account to claim your profile. No account yet? You can sign up with your email.</p>
              <Button asChild className="mt-6"><Link to={buildPostAuthPath("/claim", true)}>Continue</Link></Button>
            </>
          ) : (
            <>
              <p className="mt-3 text-muted-foreground">Signed in as {user.email}. This links your account to your athlete profile.</p>
              {state === "error" && <p role="alert" className="mt-3 text-sm text-destructive">{msg}</p>}
              <Button className="mt-6" disabled={state === "working"} onClick={redeem}>{state === "working" ? "Claiming…" : "Claim my profile"}</Button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ClaimProfile;
